import { generateFaqQuestion } from 'src/libs/faq-lib/data/generateFaqQuestion'
import { FAQTopic, FAQTopicKey } from 'src/libs/faq-lib/faq.model'

export const faqGroupManagmentData: FAQTopic = {
    topicKey: FAQTopicKey.GROUP_MANAGEMENT,
    headlineTranslationKey: 'faq-group-management-topic-headline',
    sublineTranslationKey: 'faq-group-management-topic-subline',
    categories: [
        {
            categoryKey: 'faq-group-management-general-category',
            categoryTranslationKey: 'faq-group-management-general-category',
            questions: [
                generateFaqQuestion('faq-group-management-how-does-it-work'),
                generateFaqQuestion('faq-group-management-who-can-use'),
                generateFaqQuestion('faq-group-management-what-benefits', true),
                generateFaqQuestion(
                    'faq-group-management-which-features',
                    true
                ),
                generateFaqQuestion('faq-group-management-dashboard', true),
                generateFaqQuestion('faq-group-management-request-support'),
            ],
        },
        {
            categoryKey: 'faq-group-management-structure-category',
            categoryTranslationKey: 'faq-group-management-structure-category',
            questions: [
                generateFaqQuestion('faq-group-management-create-new', true),
                generateFaqQuestion('faq-group-management-geofences'),
                generateFaqQuestion(
                    'faq-group-management-wagon-multiple',
                    true
                ),
                generateFaqQuestion(
                    'faq-group-management-select-multiple',
                    true
                ),
                generateFaqQuestion('faq-group-management-delete-groups'),
            ],
        },
        {
            categoryKey: 'faq-group-management-notifications-category',
            categoryTranslationKey:
                'faq-group-management-notifications-category',
            questions: [
                generateFaqQuestion(
                    'faq-group-management-receive-notifications'
                ),
            ],
        },
    ],
}
